const defaults = {
  foreground: {
    type: 'simple-line',
    cap: 'square',
    color: '#00BF88',
    width: 1,
  },
  background: {
    type: 'simple-line',
    color: [0, 0, 0, 0.3],
    width: 4,
  },
};

const getPolylineOption = polyline => {
  return defaults[polyline];
};

export default getPolylineOption;
